import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿El magnesio me dará sueño durante el día?',
  a: 'No, el Glicinato ayuda a regular el sistema, no es un sedante químico.'
}, {
  q: '¿Es seguro si tomo otros suplementos?',
  a: 'Generalmente sí, pero incluimos una sección para que sepas cómo combinarlo.'
}, {
  q: '¿Tengo que comprar una marca específica?',
  a: 'Te enseñamos a leer etiquetas para que elijas la mejor opción en tu país.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #111840 0%, #0D1330 100%)'
  }} data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-12 text-center" data-id="element-29">
          Preguntas <span className="text-[#4ECDC4]" data-id="element-30">frecuentes</span>
        </h2>

        <div className="space-y-4" data-id="element-31">
          {faqs.map((faq, i) => <div key={i} className="glass-card rounded-xl overflow-hidden" data-id="element-32">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left" aria-expanded={open === i} data-id="element-33">
                <span className="text-white font-medium text-base md:text-lg pr-4" data-id="element-34">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: open === i ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-35">
                  <ChevronDownIcon className="w-5 h-5 text-[#D4A853] flex-shrink-0" data-id="element-36" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-37">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-38">
                    <p className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-39">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        {/* Producto sugerido */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-12 glass-card rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6" style={{
        borderColor: 'rgba(212, 168, 83, 0.25)'
      }} data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/hy3FbkNcQDo9ytZmre9UnG/download_(3).png" alt="Magnesium Glycinate - Vitalízate Ahora" className="w-36 h-36 object-contain flex-shrink-0 product-glow" data-id="element-41" />
          <div className="text-center sm:text-left" data-id="element-42">
            <span className="text-xs uppercase tracking-widest text-[#D4A853] font-semibold" data-id="element-43">
              Producto sugerido
            </span>
            <h3 className="font-display text-xl md:text-2xl font-bold text-white mt-2 mb-3" data-id="element-44">
              Magnesio Glicinato — Vitalízate Ahora
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4" data-id="element-45">
              Elige el producto que Vitalízate Ahora te recomienda y empieza a
              ver cambios y resultados grandes en tu diario vivir. Tu sueño, tu
              energía y tu bienestar general merecen lo mejor.
            </p>
            <a href="https://vitalizateahora.com/products/magnesium-glycinate-capsules-magnesio-glicinato-para-salud-diaria-y-mejor-sueno-60-ct" target="_blank" rel="noopener noreferrer" className="inline-block px-6 py-3 rounded-full font-semibold text-sm text-[#0B1026] transition-all duration-300 hover:shadow-lg" style={{
            background: 'linear-gradient(135deg, #D4A853, #E8C478)'
          }} data-id="element-46">
              VER PRODUCTO →
            </a>
          </div>
        </motion.div>
      </div>
    </AnimatedSection>;
}